<template>
  <div class="ruler-container">
    <div class="ruler">
      <div v-if="stepTickCount" class="ruler-drag" ref="ruler" @mousedown="startDrag" @touchstart="startDrag" :style="rulerTransform">
        <div class="tick" :ref="`tick_${tick}`"
             v-for="(tick, idx) in ticks" :key="tick"
             :class="{
               'selected': tick % stepTickCount === 0 && modelValue === (Math.round(tick / stepTickCount)),
               'target-tick': tick % stepTickCount === 0,
               ['target-' + ((idx / stepTickCount) + 1)]: idx % stepTickCount === 0
             }"
        ></div>
      </div>
    </div>

    <div class="highlight-row">
      <div class="highlight-left-bg"></div>
      <div class="highlight">
        <img src="~assets/img/icons/icn_highlight_slide.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheRulerSelect",
  props: ['modelValue', 'disabled'],
  emits: ['update:modelValue'],
  data() {
    return {
      isDragging: false,
      startX: 0,
      startScrollX: 0,
      currentPosition: 0,
      rulerWidth: 0,
      velocity: 0, // 속도
      lastTimestamp: 0, // 마지막 타임스탬프
      initOffset: 0,
      isMobile: null,
      isInit: false,
      stepTickCount: null,
      ticks: null
    };
  },
  computed: {
    rulerTransform() {
      return {
        transform: `translateX(${this.currentPosition}px)`
      };
    },
    allCount() {
      return this.isMobile ? 56 : 111;
    },
  },
  methods: {
    startDrag(event) {
      event.preventDefault();
      if (this.disabled) return;
      this.isDragging = true;
      this.startX = event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
      this.startScrollX = this.currentPosition;

      window.addEventListener('mousemove', this.drag);
      window.addEventListener('touchmove', this.drag, { passive: false });
      window.addEventListener('mouseup', this.stopDrag);
      window.addEventListener('touchend', this.stopDrag);
    },
    drag(event) {
      if (this.isDragging) {
        const clientX = event.type === 'mousemove' ? event.clientX : event.touches[0].clientX;
        const diffX = clientX - this.startX;
        const newPosition = this.startScrollX + diffX;

        const currentTimestamp = performance.now();
        const deltaTime = currentTimestamp - this.lastTimestamp;
        this.lastTimestamp = currentTimestamp;

        this.velocity = (newPosition - this.currentPosition) / deltaTime;

        this.move(newPosition);
      }
    },
    highlightPeriodLabel() {
      const idx = Math.round(Math.abs(this.currentPosition) / this.allCount + 1);

      this.$emit('update:modelValue', idx);
    },
    move(newPos) {
      if (Math.abs(newPos) > this.rulerWidth) {
        this.currentPosition = -1 * this.rulerWidth;
      } else if (newPos > 0) {
        this.currentPosition = 0;
      } else {
        this.currentPosition = newPos;
      }

      this.highlightPeriodLabel();
    },
    getOffsetForStep(step) {
      let tick = step * this.stepTickCount;

      if (this.$refs[`tick_${tick}`]) {
        const elem = this.$refs[`tick_${tick}`][0];
        // console.log(`tick_${tick}`);
        // console.log(`(-1 * (${elem.getBoundingClientRect().left} + ${Math.abs(this.currentPosition)} - ${this.initOffset})) - 1`);
        return (-1 * (elem.getBoundingClientRect().left + Math.abs(this.currentPosition) - this.initOffset)) - 1;
      } else {
        // console.log('this.$refs[`tick_${tick}`] undefined ' + step + '/' + tick);
      }
    },
    stopDrag() {
      this.isDragging = false;
      window.removeEventListener('mousemove', this.drag);
      window.removeEventListener('touchmove', this.drag);
      window.removeEventListener('mouseup', this.stopDrag);
      window.removeEventListener('touchend', this.stopDrag);

      // 속도를 이용하여 움직임을 감속시키는 로직
      const deceleration = 0.05; // 감속 상수
      const animationFrame = () => {
        // 10배 확대한 값으로 업데이트
        this.move(this.currentPosition + (this.velocity * this.stepTickCount));
        this.velocity -= this.velocity * deceleration; // 속도를 감소시킴

        // 일정 속도 이하로 감속되면 멈춤
        if (Math.abs(this.velocity) < 0.01) {
          let offset = this.getOffsetForStep(this.modelValue);
          this.move(offset);
          return;
        }

        requestAnimationFrame(animationFrame);
      };

      requestAnimationFrame(animationFrame);
    },
    init() {
      if (this.isMobile === null || this.isInit) return;
      this.isInit = true;
      this.initOffset = this.$refs.ruler.getBoundingClientRect().left;
      this.rulerWidth = this.$refs.ruler.offsetWidth;


      // console.log('----ruler init: '+ this.modelValue);
      let offset = this.getOffsetForStep(this.modelValue);
      this.move(offset);
      // console.log('----ruler init move end');
    },
    moveUpdate(period) {
      // console.log('----ruler move update');
      let offset = this.getOffsetForStep(period);
      this.move(offset);
      // console.log('----ruler move update end');
    },
    setIsMobile() {
      let width = window.innerWidth;

      if (width <= 768 && !this.isMobile) {
        this.isMobile = true;
      } else if (width > 768 && (this.isMobile || this.isMobile === null)) {
        this.isMobile = false;
      }

      this.ticks = (this.isMobile ? Array.from({ length: 56 }, (_, i) => i + 5) : Array.from({ length: 111 }, (_, i) => i + 10));
      this.stepTickCount = this.isMobile ? 5 : 10;

      this.$nextTick(() => {
        this.init();
      });
    }
  },
  mounted() {
    this.setIsMobile();
  }
};
</script>

<style scoped lang="scss">
.ruler-container {
  position: relative;
  width: calc(100% + 90px);
  height: 110px;
  margin-left: -45px;
  overflow: hidden;
  //touch-action: pan-x;

  .ruler {
    position: relative;
    width: 100%;
    cursor: grab;
    padding: 0 50% 0 50%;

    .ruler-drag {
      display: inline-block;
      padding-top: 50px;
      white-space: nowrap;
      transition: 0.1s ease transform;
    }
  }

  .highlight-row {
    position: relative;
    margin-top: 25px;
    height: 5px;
    background-color: #D1D6DF;

    .highlight-left-bg {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 50%;
      z-index: 1;
      background-color: #2B5FC9;
      opacity: 0.4;
    }

    .highlight {
      position: absolute;
      left: 50%;
      margin-left: -14px;
      top: -14px;

      img {
        width: 29px;
      }
    }
  }

  .tick {
    position: relative;
    display: inline-block;
    height: 10px;
    width: 1px;
    background-color: rgba(209, 214, 223, 0.5);
    z-index: 2;
    border-radius: 2px;
    vertical-align: top;

    &:not(:last-child) {
      margin-right: 10px;
    }

    &.target-tick {
      height: 20px;
      width: 2px;

      &::before {
        position: absolute;
        width: 80px;
        text-align: center;
        top: -43px;
        left: -40px;
        color: #AAAEB6;
        font-size: 20px;
        line-height: 29px;
        font-weight: 900;

        @include respond(tablet) {
          font-size: 11px;
          line-height: 25px;
          top: -33px;
        }
      }

      &.target-1::before {
        content: '1개월'
      }

      &.target-2::before {
        content: '2개월'
      }

      &.target-3::before {
        content: '3개월'
      }

      &.target-4::before {
        content: '4개월'
      }

      &.target-5::before {
        content: '5개월'
      }

      &.target-6::before {
        content: '6개월'
      }

      &.target-7::before {
        content: '7개월'
      }

      &.target-8::before {
        content: '8개월'
      }

      &.target-9::before {
        content: '9개월'
      }

      &.target-10::before {
        content: '10개월'
      }

      &.target-11::before {
        content: '11개월'
      }

      &.target-12::before {
        content: '12개월'
      }
    }

    &.selected {
      background-color: #2B5FC9;

      &::before {
        color: #2B5FC9;

        @include respond(tablet) {
          font-size: 17px;
        }
      }
    }
  }

  .tick-label {
    position: absolute;
    bottom: -20px; /* Position below the ticks */
    transform: translateX(-50%);
    font-size: 12px;
    color: #000;
    z-index: 2;
  }

  @include respond(tablet) {
    width: calc(100% + 30px);
    margin-left: -15px;

    .ruler {
      .ruler-drag {
        padding-top: 35px;
      }
    }

    .highlight-row {
      height: 4px;
    }
  }

  @include respond(sm-height-tablet) {
    .highlight-row {
      margin-top: 20px;
    }
  }
}

</style>
